<template>
  <div class="orgDetail">
    <div class="left-box">
      <leftPage :active="2"/>
    </div>
    <div class="right-box">
      <div class="title-box">
        <div class="tit-left">
          <div class="icon-box">
            <i class="iconfont icon-zijinjianguan"></i>
          </div>
          <b>资金监管信息 <span>(以下信息有行业主管部门授权提供，机构如有异议，可自行编辑修改，保存提交至行业主管审核)</span></b>
        </div>
        <div class="page-cancel" v-if="$route.query.type" @click="$router.go(-1)">
          <i class="icon iconfont icon-jiantouzuo1"></i>返回
        </div>
      </div>
      <div class="form-content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top" class="ruleFormYan">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="是否开立培训收费专用存管账户" ref="is_kaili" prop="is_kaili">
                <div class="flex justify-start align-center">
                  <el-select v-model="ruleForm.is_kaili" placeholder="请选择" class="inp">
                    <el-option
                      v-for="item in isYes"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="ruleForm.is_kaili == 2">
              <el-form-item label="收费银行" ref="shoufei_bank" prop="shoufei_bank">
                <div class="flex justify-start align-center">
                  <el-input v-model="ruleForm.shoufei_bank" class="inp"></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="ruleForm.is_kaili == 2">
              <el-form-item label="收费银行账户" ref="shoufei_account" prop="shoufei_account">
                <div class="flex justify-start align-center">
                  <el-input v-model="ruleForm.shoufei_account" class="inp"></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="ruleForm.is_kaili == 2">
              <el-form-item label="收费银行账号" ref="shoufei_number" prop="shoufei_number">
                <div class="flex justify-start align-center">
                  <el-input v-model="ruleForm.shoufei_number" class="inp"></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="ruleForm.is_kaili == 1">
              <el-form-item label="培训收费专用账户户名" ref="kaihuming" prop="kaihuming">
                <div class="flex justify-start align-center">
                  <el-input v-model="ruleForm.kaihuming" class="inp"></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="ruleForm.is_kaili == 1">
              <el-form-item label="培训收费专用账户帐号" ref="zhang_hao" prop="zhang_hao">
                <div class="flex justify-start align-center">
                  <el-input v-model="ruleForm.zhang_hao" class="inp"></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="ruleForm.is_kaili == 1">
              <el-form-item label="培训收费专用账户开户行" ref="kai_hu_hang" prop="kai_hu_hang">
                <div class="flex justify-start align-center">
                  <el-input v-model="ruleForm.kai_hu_hang" class="inp"></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="ruleForm.is_kaili == 1">
              <el-form-item label="培训收费专用账户余额（元）" ref="yue" prop="yue">
                <div class="flex justify-start align-center">
                  <el-input v-model="ruleForm.yue" class="inp">
                    <template slot="append">
                      元
                    </template>
                  </el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="预收资金数额">
                <div class="flex justify-start align-center">
                  <el-input v-model="ruleForm.last_yushou" readonly class="inp">
                    <template slot="append">
                      元
                    </template>
                  </el-input>
                  <div class="tips">
                    <i class="iconfont icon-xinxitishi"></i>
                    注：此处只展示最新一个月的预收资金数
                  </div>
                  <div class="btnUp act" v-if="ruleForm.last_yushou" @click="saveYuShou">保持</div>
                  <div class="btnUp" @click="dialogVisible = true"><i class="iconfont icon-tianjia"></i>填写预收资金数额</div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否开立风险保证金账户" ref="is_kaili_fengxian" prop="is_kaili_fengxian">
                <div class="flex justify-start align-center">
                  <el-select v-model="ruleForm.is_kaili_fengxian" placeholder="请选择" class="inp">
                    <el-option
                      v-for="item in isYes"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="ruleForm.is_kaili_fengxian == 1">
              <el-form-item label="风险保证金账户户名" ref="kaihuming_fengxian" prop="kaihuming_fengxian">
                <div class="flex justify-start align-center">
                  <el-input v-model="ruleForm.kaihuming_fengxian" class="inp"></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="ruleForm.is_kaili_fengxian == 1">
              <el-form-item label="风险保证金帐户帐号" ref="zhang_hao_fengxian" prop="zhang_hao_fengxian">
                <div class="flex justify-start align-center">
                  <el-input v-model="ruleForm.zhang_hao_fengxian" class="inp"></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="ruleForm.is_kaili_fengxian == 1">
              <el-form-item label="风险保证金开户行" ref="kai_hu_hang_fengxian" prop="kai_hu_hang_fengxian">
                <div class="flex justify-start align-center">
                  <el-input v-model="ruleForm.kai_hu_hang_fengxian" class="inp"></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="ruleForm.is_kaili_fengxian == 1">
              <el-form-item label="风险保证金余额（元）" ref="yue_fengxian" prop="yue_fengxian">
                <div class="flex justify-start align-center">
                  <el-input v-model="ruleForm.yue_fengxian" class="inp">
                    <template slot="append">
                      元
                    </template>
                  </el-input>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="btn-box">
          <div class="btn" @click="submitForm('ruleForm',1)">临时保存</div>
          <div class="btn margin-left-xs" @click="submitForm('ruleForm',2)">提交</div>
        </div>
      </div>

    </div>
    <moneyDialog :dialogVisible="dialogVisible" @handleClose="handleClose"/>
  </div>
</template>
<script>
import leftPage from "@/views/home/common/leftPage";
import moneyDialog from "@/views/home/dialog/moneyDialog";
import {
  scrollIntoView
} from "@/utils/utils";
import {
  isYes,
  xiaofangOptions,
  zhiduOptions
} from "@/utils/const";
import {
  save_yushou,
  save_zijin,
  zijin
} from "@/api/index";

export default {
  name: "orgDetail",
  data() {
    return {
      dialogVisible: false,
      isYes: isYes,
      zhiduOptions: zhiduOptions,
      xiaofangOptions: xiaofangOptions,
      ruleForm: {
        is_kaili: '', // 是否开立资金存管账户
        shoufei_bank: '', // 收费银行
        shoufei_account: '', // 收费银行账户
        shoufei_number: '', // 收费银行账号
        kaihuming: '', // 资金存管账户开户名称
        zhang_hao: '', // 银行存管账号
        kai_hu_hang: '', // 资金存管账户开户银行
        last_yushou: '', // 预收资金数额
        yue: '', // 银行存管账户余额
        is_kaili_fengxian: '', // 是否开立风险保证金账户
        kaihuming_fengxian: '', // 风险保证金账户开户名称
        zhang_hao_fengxian: '', // 风险保证金账号
        kai_hu_hang_fengxian: '', // 风险保证金开户银行
        yue_fengxian: '', // 风险保证金金额
      },

      rules: {
        yue_fengxian: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        shoufei_bank: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        shoufei_account: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        shoufei_number: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        kaihuming: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        kai_hu_hang_fengxian: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        zhang_hao_fengxian: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        kaihuming_fengxian: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        yue: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        kai_hu_hang: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        zhang_hao: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        reg_address: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        is_kaili_fengxian: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        is_kaili: [
          {required: false, message: '请选择', trigger: 'change'}
        ]
      }
    }
  },
  components: {
    leftPage,
    moneyDialog
  },
  created() {
    this.$emit("setActive", {
      headActive: 2
    })
    this.init()
  },
  methods: {
    async init() {
      let _data = await zijin();
      if (_data.status == 200) {
        this.ruleForm = {
          is_kaili: _data.data.is_kaili, // 是否开立资金存管账户
          shoufei_bank: _data.data.shoufei_bank, // 收费银行
          shoufei_account: _data.data.shoufei_account, // 收费银行账户
          shoufei_number: _data.data.shoufei_number, // 收费银行账号
          kaihuming: _data.data.kaihuming, // 资金存管账户开户名称
          zhang_hao: _data.data.zhang_hao, // 银行存管账号
          kai_hu_hang: _data.data.kai_hu_hang, // 资金存管账户开户银行
          last_yushou: _data.data.last_yushou, // 资金存管账户开户银行
          yue: _data.data.yue, // 银行存管账户余额
          is_kaili_fengxian: _data.data.is_kaili_fengxian, // 是否开立风险保证金账户
          kaihuming_fengxian: _data.data.kaihuming_fengxian, // 风险保证金账户开户名称
          zhang_hao_fengxian: _data.data.zhang_hao_fengxian, // 风险保证金账号
          kai_hu_hang_fengxian: _data.data.kai_hu_hang_fengxian, // 风险保证金开户银行
          yue_fengxian: _data.data.yue_fengxian // 风险保证金金额
        }
      }
    },
    submitForm(formName, zancun) {
      if (zancun == 1) {
        this.submitInfo(zancun)
      } else {
        this.$refs[formName].validate((valid, validates) => {
          if (valid) {
            this.submitInfo(zancun)
          } else {
            scrollIntoView(this, validates)
          }
        });
      }
    },

    async saveYuShou() {
      let _data = await save_yushou(
        '', '', '', 1
      );
      if (_data.status == 200) {
        this.$message.success(_data.msg)
      } else {
        this.$message.error(_data.msg)
      }
    },

    async submitInfo(zancun) {
      let _data = await save_zijin(
        zancun,
        this.ruleForm.is_kaili,
        this.ruleForm.shoufei_bank,
        this.ruleForm.shoufei_account,
        this.ruleForm.shoufei_number,
        this.ruleForm.kaihuming,
        this.ruleForm.zhang_hao,
        this.ruleForm.kai_hu_hang,
        this.ruleForm.yue,
        this.ruleForm.is_kaili_fengxian,
        this.ruleForm.kaihuming_fengxian,
        this.ruleForm.zhang_hao_fengxian,
        this.ruleForm.kai_hu_hang_fengxian,
        this.ruleForm.yue_fengxian
      );
      if (_data.status === 200) {
        this.$message.success(_data.msg)
      } else {
        this.$message.error(_data.msg)
      }
    },

    handleClose() {
      this.dialogVisible = false
      this.init()
    },
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.orgDetail {
  width: 100%;
  min-height: calc(100vh - (173px + 159px));
  background: #f3f5f7;
  padding: 20px;
  display: flex;
  justify-content: flex-start;

  .right-box {
    flex: 1;
    margin-left: 25px;
    background-image: linear-gradient(0deg,
      #ffffff 84%,
      #edf6ff 100%);
    border-radius: 8px;
    border: solid 1px #ffffff;
    padding: 0 20px;

    .form-content {
      width: 100%;
      padding: 20px 0;

      .width {
        width: 400px;
      }

      .btn-box {
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 30px 0;

        .btn {
          width: 180px;
          height: 40px;
          background-image: linear-gradient(0deg,
            #2791ff 0%,
            #81b6ff 100%);
          border-radius: 20px;
          text-align: center;
          line-height: 40px;
          font-size: 16px;
          letter-spacing: 1px;
          color: #ffffff;
          cursor: pointer;
        }
      }

      .add {
        width: 36px;
        margin-left: 10px;
        cursor: pointer;
      }

      .inp {
        flex: 1;
      }

      .tips {
        width: max-content;
        padding: 0 10px;
        height: 36px;
        background-color: #fef0ef;
        border-radius: 4px;
        margin-left: 10px;
        font-size: 14px;
        color: #f34336;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        line-height: 16px;

        i {
          font-size: 20px;
          color: #f34336;
          margin-right: 4px;
        }

        &.width {
          width: 160px;
        }
      }

      .look {
        width: max-content;
        padding: 0 10px;
        height: 36px;
        border: 1px solid #2791ff;
        color: #2791ff;
        line-height: 34px;
        text-align: center;
        font-size: 14px;
        margin-left: 10px;
        border-radius: 4px;
      }

      .btnUp {
        width: max-content;
        padding: 0 10px;
        height: 36px;
        margin-left: 10px;
        background-image: linear-gradient(90deg,
          #2791ff 0%,
          #81b6ff 100%);
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: #ffffff;
        cursor: pointer;

        &.act {
          background-image: linear-gradient(90deg,
            #ffbb03 0%,
            #fdc235 100%);
        }

        i {
          font-size: 20px;
          color: #ffffff;
          margin-right: 5px;
          font-weight: 100;
        }
      }
    }

    .title-box {
      width: 100%;
      height: 60px;
      border-bottom: solid 2px #e3e7f0;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .tit-left {
        display: flex;
        justify-content: flex-start;
        padding-top: 25px;
        padding-bottom: 15px;

        .icon-box {
          width: 30px;
          height: 30px;
          background-image: linear-gradient(-30deg,
            #3579fb 0%,
            #44a3ff 100%);
          box-shadow: 0px 10px 10px 0px rgba(50, 150, 255, 0.3);
          border-radius: 10px;
          text-align: center;
          line-height: 30px;

          i {
            font-size: 18px;
            color: #ffffff;
          }
        }

        b {
          font-size: 22px;
          color: #16181d;
          font-weight: bold;
          margin-left: 5px;

          span {
            font-size: 18px;
            color: #f74945;
          }
        }
      }
    }
  }

  .left-box {
    width: 260px;
  }
}
</style>


